import { AppRouter } from "@/router";
import { useVersionCheck } from "@/hooks/useVersionCheck";
import { useGetUserInfo } from "./hooks/api/useGetUserInfo";
import { NoAuthSubscriber } from "@/components/NoAuthSubscriber";
import { CustomerSupportEntry } from "@/components/profile/CustomerSupportEntry";
import { useUserStore } from "@/store/useUserStore";

export default function App() {
  useVersionCheck();
  const { userInfo } = useUserStore();
  const { data: userInfoFromApi } = useGetUserInfo();
  const currentUserInfo = userInfoFromApi ?? userInfo;
  // 未注册/未登录不展示客服入口；Team B（AILiquid）走内嵌在线客服，
  // Team A（AIFortuna）及团队未知的用户走 Telegram 客服
  const showCustomerSupport = !!currentUserInfo?.uid;
  const supportVariant =
    String(currentUserInfo?.team ?? "").toUpperCase() === "B"
      ? "tawk"
      : "telegram";

  return (
    <>
      <NoAuthSubscriber />
      <AppRouter />
      {showCustomerSupport && (
        <CustomerSupportEntry
          walletAddress={currentUserInfo.address}
          variant={supportVariant}
        />
      )}
    </>
  );
}
